module.exports = __webpack_public_path__ + "img/selected0-min.338a8a8f.png";